<template>
  <div class="text-editor-text">
    <textarea name="editor1" id="editor1" rows="10" cols="80">
        This is my textarea to be replaced with CKEditor.
    </textarea>
  </div>
</template>

<script>
export default {
  name: 'sds',
};
</script>

<style>
</style>